var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVeloLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218.686,
    height: 250,
    viewBox: "0 0 218.686 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tw0xomixra"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H218.686V250H0z",
    transform: "translate(611.06 837.493)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00add5",
    d: "M611.06 894.19l156.14 70.942-11.862 5.39-144.278-65.555v47.814l91.663 41.649-74.87 34.017-.023-10.654 51.308-23.313-68.08-30.932v18.41l27.405 12.452-27.4 12.451v47.944l132.5-60.2-115.732-52.585v-10.9l127.726 58.033 52.557-23.88-197.055-89.535z",
    transform: "translate(-611.059 -837.493)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tw0xomixra)",
    transform: "translate(-611.059 -837.493)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M755.541 914.13l-11.641-5.291v35.392h-58.933v12.841h70.574zm-70.574 101.77h70.575v-45.286l-11.547-5.247v37.688h-17.967v-16.42l-11.547-5.246v21.666h-17.968v-29.829l-11.546-5.247zm0 5.332v12.94l44.441 20.192-44.441 20.193v12.94l72.921-33.133zm35.287-171.135c14.012 0 24.958 10.837 24.958 23.972s-10.946 24.083-24.958 24.083c-13.9 0-24.958-10.947-24.958-24.083s11.056-23.972 24.958-23.972m0 60.562a36.581 36.581 0 1 0-36.581-36.581 36.521 36.521 0 0 0 36.581 36.581"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloLogo);
export default __webpack_public_path__ + "static/media/velo-logo.fecccc24e19c46174928c395a029b3f4.svg";
export { ForwardRef as ReactComponent };